import request from "@/utils/request";
//选中学校返回对比数据
export function GetSchoolComparison(data) {
  return request({
    url: "/html/SchoolComparison",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/SchoolComparison.js